import { render, staticRenderFns } from "./DistributeForm.vue?vue&type=template&id=2e830490&scoped=true"
import script from "./DistributeForm.vue?vue&type=script&lang=js"
export * from "./DistributeForm.vue?vue&type=script&lang=js"
import style0 from "./DistributeForm.vue?vue&type=style&index=0&id=2e830490&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e830490",
  null
  
)

export default component.exports